import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getRole(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}role/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addRole(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}role/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getByIdRole(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}role/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateRole(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}role/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddRoleType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/role/type/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddOA() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/oaname/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}